<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2 class="text-bold text-1100">
                            Telegram Webapp
                            <span class="fw-normal text-700 ms-2">({{items.length}})</span>
                        </h2>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>


                <div class="mx-n4 mx-lg-n6 px-4 px-lg-6 mb-9 bg-white border-y border-300 mt-2 position-relative top-1" v-show="!preloader">
                    <div class="table-responsive scrollbar ms-n1 ps-1">
                    
                        <div class="table table-responsive-small">
                            <datatable
                                :columns="columns" 
                                :data="items"
                                :per-page="pager.per_page">
                                <template scope="{ row, columns }">
                                    <tr>
                                        <td>{{ row.id }}</td>
                                        <td>{{ row.token }}</td>
                                        <td>{{ row.url }}</td>
                                        <td>{{ $moment(row.created_at).format('YYYY-MM-DD H:mm:ss') }}</td>
                                        <td>{{ utils.statuses.find(el => el.key == row.status).name }}</td>
                                        <td>
                                            <button
                                                @click="$modal.show('update-item'), data.update.id = row.id, data.update.token = row.token, data.update.url = row.url"
                                                content="Редактировать" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                class="btn btn-soft-primary btn-sm me-1 mb-1">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </datatable>
                        </div>

                        <div class="col-auto d-flex">
                            <ul class="mb-3 pagination">
                                <datatable-pager v-model="pager.page" type="abbreviated"></datatable-pager>
                            </ul>
                        </div>

                    </div>
                </div>


                <!-- Modals -->

                <modal 
                    name="update-item"
                    height="auto"
                    :shiftY="0.3"
                    :adaptive="true">
                    <form class="row g-3" v-on:submit.prevent="updateItem">
                        <div class="col-sm-12 col-md-12">
                            <div class="form-floating">
                                <input
                                    v-model="data.update.token"
                                    @input="errors.update.token = null"
                                    :class="{'is-invalid': errors.update.token}"
                                    placeholder="Токен"
                                    class="form-control" 
                                    type="text"/>
                                <label>Токен</label>
                                <div class="invalid-feedback">{{errors.update.token}}</div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div class="form-floating">
                                <input
                                    v-model="data.update.url"
                                    @input="errors.update.url = null"
                                    :class="{'is-invalid': errors.update.url}"
                                    placeholder="Ссылка (https://t.me/mybot/app)"
                                    class="form-control" 
                                    type="text"/>
                                <label>Ссылка (https://t.me/mybot/app)</label>
                                <div class="invalid-feedback">{{errors.update.url}}</div>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3">
                            <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                <span>Сохранить</span>
                            </button>
                        </div>
                    </form>
                </modal>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['status'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            status_item_preloader: false,
            pager: {
                per_page: 25,
                page: 0
            },
            items: [],
            search: {
                status: null
            },
            columns: [
                {label: 'ID'},
                {label: 'Токен'},
                {label: 'Ссылка'},
                {label: 'Дата создания'},
                {label: 'Статус'},
                {label: ''}
            ],
            data: {
                update: {
                    id: null,
                    token: null,
                    url: null
                }
            },
            errors: {
                update: {
                    id: false,
                    token: false,
                    url: false
                }
            },
            utils: {
                statuses: [
                    {
                        name: 'Включена',
                        key: 1
                    },
                    {
                        name: 'Отключена',
                        key: 0
                    }
                ]
            }
        }
    },
    methods: {
        getItems () {
            this.preloader = true
            this.$axios.post('/settings/telegram/webapp/items', JSON.stringify({
                search: {
                    status: this.search.status != null ? this.search.status.key : null
                }
            }))
            .then((response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.items = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })
        },
        updateItem () {
            if(!this.data.update.token) {
                this.errors.update.token = 'Это поле обязательно'
                return
            }
            if(!this.data.update.url) {
                this.errors.update.url = 'Это поле обязательно'
                return
            }
            
            this.btn_preloader = true
            this.$axios.post('/settings/telegram/webapp/update', JSON.stringify({
                id: this.data.update.id,
                token: this.data.update.token,
                url: this.data.update.url
            }))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.getItems()
                        this.$modal.hide('update-item')
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errors.update[response.field] = response.message
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        }
    },
    beforeMount () {
        this.getItems()
    }
}
</script>
